import { createStore } from 'vuex'
// import * as fb from '../firebase'
// import router from '../router/index'

import loginStore from './modules/login'
import dailyStore from './modules/daily'
import goalStore from './modules/goals'
import goalDetailStore from './modules/goalsdetails'
import targetStore from './modules/targets'
import winStore from './modules/wins'

export default createStore({
  modules: {
    loginStore,
    dailyStore,
    goalStore,
    goalDetailStore,
    targetStore,
    winStore,
  },
})
